<div class="client-info">
    <div class="container">
        <div class="box sucess-box">
            <div class="logo">
                <img src="./../../../assets/logo_SBQ.png" style="width: 50%; height: 50%;" alt="Logo" />
            </div>
            <img src="./../../../assets/green-checkmark-icon.svg" class="check-mark" alt="Logo" title="Logo" />
            <span class="title-text">{{message}}</span>
            <span class="sub-text">We'll use it to improve our services. You can also send us an email to
                <a href="mailto:feedback@smartbooqing.nl">feedback&#64;smartbooqing.nl</a> with additional
                suggestions.</span>
        </div>
    </div>
</div>